import { useEffect, useState } from 'react';
import { ACCOUNT_RESOURCE_STATUS } from '@enums';
import { useStore } from '@hooks';

export const useProgress = (setLoading) => {
    const store = useStore();
    const { productsSyncProgress, isManual } = store.accountsStore;
    const { getProducts } = store.productsStore;
    const isNotCompleted = productsSyncProgress?.status !== ACCOUNT_RESOURCE_STATUS.COMPLETED;
    const inProgress = [ACCOUNT_RESOURCE_STATUS.PENDING, ACCOUNT_RESOURCE_STATUS.IN_PROGRESS].includes(
        productsSyncProgress?.status
    );
    const defaultShowProgress = isManual ? !isNaN(productsSyncProgress?.status) && inProgress : isNotCompleted;
    const [showProgress, setShowProgress] = useState(defaultShowProgress);

    useEffect(() => {
        let timerId;

        if (productsSyncProgress?.status === ACCOUNT_RESOURCE_STATUS.COMPLETED && showProgress) {
            timerId = setTimeout(async () => {
                setShowProgress(false);
                setLoading(true);
                await getProducts();
                setLoading(false);
            }, 2000);
        }

        return () => clearTimeout(timerId);
    }, [productsSyncProgress?.status]);

    return showProgress;
};
